import { Routes, Route } from 'react-router-dom';
import { FormContextProvider } from 'contexts/FormContext';
import ThMigrationFormPage from './migration-form';

export default function ThMigrationRoutes() {
  return (
    <FormContextProvider market="th">
      <Routes>
        <Route path="migration-form" element={<ThMigrationFormPage />} />
      </Routes>
    </FormContextProvider>
  );
}
